import "./CreateDirectConnection.html";
import "./CreateDirectConnection.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import CreateDirectConnectionComponentController from "./CreateDirectConnectionComponentController";

export default class CreateDirectConnectionComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = CreateDirectConnectionComponentController;
        this.templateUrl =
            "/App/Components/Site/DesignAndPlanning/" +
            "SelectedEquipment/EquipmentDetails/EditDirectConnections/CreateDirectConnection.html";
    }
}

module("mmManagePortal").component("irEditDirectConnections", new CreateDirectConnectionComponent());
